import * as React from 'react';
import { Input } from '@app/src/components/Input';
import { Field } from '@app/src/components/Field';

export const RenderInput = ({
  label,
  type,
  disabled,
  maxLength,
  portionWidth,
  meta: { error, touched },
  newData,
  input,
  ...rest
}) => {
  let isError = (error && touched) ? error : '';
  return(
    <Field label={label} portionWidth={portionWidth} errorMessage={isError} defaultValue={newData} {...rest}>
      <Input
        type={type}
        disabled={disabled}
        maxLength={maxLength}
        {...input}
        {...rest}
        error={!!isError} />
    </Field>
  );
}